import React from 'react'
import Banner from '../Components/Banner/Banner'
import CoinsTable from '../Components/CoinsTable'
import CryptoNews from '../Components/CryptoNews'

const Homepage = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
      <CryptoNews />
    </>
  )
}

export default Homepage